import React, { useState } from 'react';
import { Activity, BarChart3, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../ui/select';
import { AnalisisCaso } from './AnalisisCaso';
import { MovimientosCasoTabla } from './MovimientosCasoTabla';
import { periodoEpisodio } from './episodioUtils';

const CASO = '__caso__';

// F3: movimientos y análisis del caso, filtrados al episodio seleccionado o al caso completo.
export const CasoMovimientosAnalisis = ({ caseId, episodios, episodioId, onEpisodio, onAgregar, onQuitar, version }) => {
  const [vista, setVista] = useState('movimientos');
  const valor = episodios.some((e) => e.id === episodioId) ? episodioId : CASO;
  return (
    <div className="space-y-4" data-testid="caso-movimientos-analisis">
      <div className="flex flex-wrap items-center gap-3">
        <Select value={valor} onValueChange={(v) => onEpisodio(v === CASO ? null : v)}>
          <SelectTrigger className="w-[360px] bg-white" data-testid="f3-selector-episodio"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={CASO}>Caso completo</SelectItem>
            {episodios.map((e) => (
              <SelectItem key={e.id} value={e.id}>{e.monitor} · {periodoEpisodio(e)}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <div className="inline-flex rounded-lg border border-slate-200 bg-slate-50 p-0.5">
          {[['movimientos', 'Movimientos', Activity], ['analisis', 'Análisis', BarChart3]].map(([k, l, I]) => (
            <button key={k} type="button" onClick={() => setVista(k)} data-testid={`f3-vista-${k}`}
              className={`flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm transition-colors ${vista === k ? 'bg-white font-semibold text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}>
              <I size={14} /> {l}
            </button>
          ))}
        </div>
        <Button size="sm" variant="outline" onClick={onAgregar} className="ml-auto gap-1" data-testid="f3-agregar-movimiento">
          <Plus size={14} /> Agregar movimiento
        </Button>
      </div>
      {vista === 'movimientos'
        ? <MovimientosCasoTabla caseId={caseId} episodioId={valor === CASO ? null : valor} onQuitar={valor === CASO ? onQuitar : undefined} version={version} />
        : <AnalisisCaso casoId={caseId} episodioId={valor === CASO ? null : valor} />}
    </div>
  );
};

export default CasoMovimientosAnalisis;
